import { render } from "./Notes.vue?vue&type=template&id=2f9b04dc&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"

import "./Notes.vue?vue&type=style&index=0&id=2f9b04dc&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9b04dc"]])

export default __exports__